/**
 * @ngdoc service
 * @name errorHandler
 * @description
 * This service handle the show of errors.
 *
 * @memberof common
 */
class ErrorHandler {
  /**
   * Class constructor.
   * @param {Service} $log    To log any errors.
   * @param {Service} notify  To display any errors messages.
   * @ignore
   */
  constructor(
    $log,
    notify,
  ) {
    'ngInject';

    /**
     * The local reference to the `$log` service.
     * @type {Object}
     */
    this.$log = $log;
    /**
     * The local reference to the `notify` service.
     * @type {Object}
     */
    this.notify = notify;

    // eslint-disable-next-line angular/module-getter
    this.notify.config({
      duration: 5000,
      maximumOpen: 1,
      startTop: 16,
    });
  }
  /**
   * Handle an error to obtain the message or a default one
   * and call the showErrorMessage function.
   * @param {Error} err the error to handle.
   */
  handleError(err) {
    const msg = (
      err.data &&
            err.data.data &&
            (err.data.data.error_long_message || err.data.data.message)
    )
      ? err.data.data.error_long_message || err.data.data.message
      : 'Oops, something went wrong';
    this.showErrorMessage(msg);
    this.$log.error(err);
  }
  /**
   * Handle the display and loggin of a error message.
   * @param {String} msg the error message to show.
   */
  showErrorMessage(msg) {
    this.notify(msg);
  }
}

export default ErrorHandler;



// WEBPACK FOOTER //
// ./src/frontend/modules/common/services/errorHandler.js